<div class="tree-select-container">
  <mat-form-field appearance="outline" class="full-width custom-mat-field">
    <mat-label *ngIf="!control.value">{{ label | translate }}</mat-label>
    <input
      matInput
      [formControl]="control"
      [placeholder]="placeholder"
      [disabled]="disabled"
      readonly
      (click)="toggleDropdown()"
      [value]="getSelectedDisplayName()"
      class="tree-select-input">
    
    <mat-icon 
      matSuffix 
      class="dropdown-icon"
      (click)="toggleDropdown()"
      [class.rotated]="isDropdownOpen">
      keyboard_arrow_down
    </mat-icon>
    
    <mat-icon 
      *ngIf="control.value && !disabled" 
      matSuffix 
      class="clear-icon" 
      (click)="control.setValue(''); selectedNode = null; selectionChange.emit(''); $event.stopPropagation()">
      close
    </mat-icon>
  </mat-form-field>

  <!-- Dropdown Panel -->
  <div 
    class="dropdown-panel" 
    [class.show]="isDropdownOpen"
    *ngIf="isDropdownOpen">
    
    <!-- Search Input -->
    <div class="search-container">
      <div class="search-field-wrapper">
        <label class="search-label">Tìm kiếm...</label>
        <mat-form-field appearance="outline" class="search-field">
          <input
            matInput
            [(ngModel)]="searchText"
            (input)="onSearchInput()"
            placeholder="Nhập tên thư mục...">
          <mat-icon 
            *ngIf="searchText" 
            matSuffix 
            class="clear-search-icon" 
            (click)="clearSearch()">
            close
          </mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- Tree Nodes -->
    <div class="tree-container">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
        <span class="loading-text">Đang tải danh sách thư mục...</span>
      </div>
      
      <!-- Debug info -->
      <div *ngIf="!isLoading && filteredNodes.length === 0" class="debug-info">
        Không có dữ liệu để hiển thị. Số lượng nodes: {{ treeNodes.length }}, filtered: {{ filteredNodes.length }}
      </div>
      
      <!-- Debug info for nodes -->
      <!-- <div *ngIf="!isLoading && filteredNodes.length > 0" class="debug-info">
        Hiển thị {{ filteredNodes.length }} thư mục. Node đầu tiên: {{ filteredNodes[0].name }}
      </div> -->
      
      <div 
        *ngFor="let node of filteredNodes; trackBy: trackByNodeId" 
        class="tree-node"
        [style.margin-left.px]="node.level * 20">
        
        <!-- Node Content -->
        <div class="node-content"
             [class.has-children]="node.children && node.children.length > 0"
             [class.selected]="selectedNode?.id === node.id">
          
          <!-- Expand/Collapse Button -->
          <button 
            *ngIf="node.children && node.children.length > 0"
            class="expand-btn"
            (click)="toggleNode(node)"
            [class.expanded]="node.expanded">
            <mat-icon class="expand-icon">
              {{ node.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>
          
          <!-- Empty space for nodes without children -->
          <div *ngIf="!node.children || node.children.length === 0" class="expand-placeholder"></div>
          
          <!-- Folder Info -->
          <div class="folder-info" (click)="toggleNode(node)">
            <!-- Folder Icon -->
            <mat-icon class="folder-icon">
              {{ node.children && node.children.length > 0 ? 'folder' : 'folder_open' }}
            </mat-icon>
            
            <!-- Node Name -->
            <span class="node-name" [title]="node.fullPath">
              {{ cleanNodeName(node.name) }}
            </span>
          </div>
          
          <!-- Select Button -->
          <button 
            class="select-btn"
            (click)="selectNode(node)"
            [class.selected]="selectedNode?.id === node.id"
            title="Chọn thư mục này">
            <mat-icon>check</mat-icon>
            Chọn
          </button>
        </div>

        <!-- Children (recursive) -->
        <div 
          *ngIf="node.expanded && node.children && node.children.length > 0"
          class="children-container">
          <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node.children }"></ng-container>
        </div>
      </div>
    </div>

    <!-- No Results Message -->
    <div *ngIf="filteredNodes.length === 0 && searchText" class="no-results">
      Không tìm thấy thư mục nào
    </div>
  </div>
</div>

<!-- Recursive Template -->
<ng-template #treeNodeTemplate let-nodes>
  <div 
    *ngFor="let node of nodes; trackBy: trackByNodeId" 
    class="tree-node"
    [style.margin-left.px]="node.level * 20">
    
    <!-- Node Content -->
    <div class="node-content"
         [class.has-children]="node.children && node.children.length > 0"
         [class.selected]="selectedNode?.id === node.id">
      
      <!-- Expand/Collapse Button -->
      <button 
        *ngIf="node.children && node.children.length > 0"
        class="expand-btn"
        (click)="toggleNode(node)"
        [class.expanded]="node.expanded">
        <mat-icon class="expand-icon">
          {{ node.expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>
      
      <!-- Empty space for nodes without children -->
      <div *ngIf="!node.children || node.children.length === 0" class="expand-placeholder"></div>
      
      <!-- Folder Info -->
      <div class="folder-info" (click)="toggleNode(node)">
        <!-- Folder Icon -->
        <mat-icon class="folder-icon">
          {{ node.children && node.children.length > 0 ? 'folder' : 'folder_open' }}
        </mat-icon>
        
        <!-- Node Name -->
        <span class="node-name" [title]="node.fullPath">
          {{ cleanNodeName(node.name) }}
        </span>
      </div>
      
      <!-- Select Button -->
      <button 
        class="select-btn"
        (click)="selectNode(node)"
        [class.selected]="selectedNode?.id === node.id"
        title="Chọn thư mục này">
        <mat-icon>check</mat-icon>
        Chọn
      </button>
    </div> 

    <!-- Children (recursive) --> 
    <div 
      *ngIf="node.expanded && node.children && node.children.length > 0"
      class="children-container">
      <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node.children }"></ng-container>
    </div>
  </div>
</ng-template>

<!-- Error Message -->
<span class="errorTxt__custom" *ngIf="control?.invalid && (control?.dirty || isSubmit)">
  {{ errorMessage }}
</span>
